import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ReimburseDialogComponent } from '../reimburse-dialog/reimburse-dialog.component';
import { JaldeeReportService } from 'src/app/services/jaldee-report.service';
import { Location } from '@angular/common';
@Component({
  selector: 'app-view-jaldee-report',
  templateUrl: './view-jaldee-report.component.html',
  styleUrls: ['./view-jaldee-report.component.css']
})
export class ViewJaldeeReportComponent implements OnInit {
  id: any;
  report: any;
  jaldeeAccount: any = [];
  coupon: Object;
  uId: any;
  invoiceid: any;
  paymentStatus = '';
  reimburse: any = [];
  couponList: any;
  data: any;
  paymentstatus: any;
  btndisabled = false;
  showReimbursePay = true;
  settlementAmount;
  totalRefundAmount;
  balFromPrevReport;
  jaldeeCash: any = [];
  jCashTotal;
  totalRefundAmountcash;
  amt;
  constructor(private activatedRoute: ActivatedRoute, private router: Router, private dialog: MatDialog,
    private reportService: JaldeeReportService, private locObj: Location) {
    this.activatedRoute
      .params
      .subscribe(params => {
        this.data = JSON.parse(params['details']);
        console.log('data..........' + JSON.stringify(this.data));
        this.paymentStatus = this.data.status;
        if (this.paymentStatus === 'PAID' || this.paymentStatus === 'INDISPUTE') {
          this.showReimbursePay = false;
        }
      });
    this.report = this.activatedRoute.snapshot.data['reportDetails'];
    if(this.report.jaldeeBankStatement){
      this.settlementAmount = this.report.jaldeeBankStatement.jbankDetails.settlementAmount;
    this.totalRefundAmount = this.report.jaldeeBankStatement.jbankDetails.totalRefundAmount;
    this.balFromPrevReport = this.report.jaldeeBankStatement.jbankDetails.balanceFromPrevReport;
    }
    if(this.report.jCashStatement){
      this.jCashTotal = this.report.jCashStatement.jCashDetails.jCashTotal;
      this.totalRefundAmountcash = this.report.jCashStatement.jCashDetails.totalRefundAmount;
      this.amt = this.report.jCashStatement.amt;
    }
    console.log('report........' + this.report);
    console.log(JSON.stringify(this.report));
    if (this.report.jaldeeBankStatement !== null) {
      this.jaldeeAccount = this.report.jaldeeBankStatement.entries;
    }
    if (this.report.jCashStatement) {
      this.jaldeeCash = this.report.jCashStatement.entries;
    }
    if (this.report.grandTotal < 0) {
      this.showReimbursePay = false;
    }
    this.couponList = this.report.jaldeeCouponReimbursableExpense;
    this.reportService.getReimbursePaymentDetails(this.report.invoiceId)
      .subscribe(reimburseRes => {
        this.reimburse = reimburseRes;
        console.log(this.reimburse);
      },
        (error) => {
          console.log(error.error);
        });
  }
  ngOnInit() {
  }
  goBacktoList() {
    // this.router.navigate(['../../../list'], { relativeTo: this.activatedRoute });
    this.locObj.back();
  }
  jaldee_reimburse() {
    this.btndisabled = true;
    const dialogRef = this.dialog.open(ReimburseDialogComponent, {
      width: '1000px',
      data: this.data
    });
    dialogRef.afterClosed().subscribe(result => {
      this.btndisabled = false;
        //  this.router.navigate(['../../../../list'], { relativeTo: this.activatedRoute });
    });
  }
  printComponent(cmpName) {
    const printContent = document.getElementById(cmpName);
    const WindowPrt = window.open('', '', 'left=0,top=0,width=900,height=900,toolbar=0,scrollbars=0,status=0');
    WindowPrt.document.write(printContent.innerHTML);
    WindowPrt.document.close();
    WindowPrt.focus();
    WindowPrt.print();
    WindowPrt.close();
  }
}
